<template>
  <div class="pikaplay-container">
    <div class="result-card">
      <div class="result-flex-wrap">
        <div class="wheel-container">
          <div id="wheel-result" class="hidden"></div>
          <canvas id="wheel" width="600" height="600"></canvas>
          <button id="pick-button" @click="handlePickButtonClick">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>

          
          <!-- 設定按鈕 -->
          <button id="setting-button" class="setting-button" @click="goToSettings">
            <svg-icon icon-class="setting-game"  class="setting-icon"  />
          </button>
        </div>
      </div>
    </div>

    <!-- 音效元素 -->
    <audio ref="wheelSound" preload="auto" volume="1.0">
      <source src="@/assets/HTwbActAssets/gameSounds/positive-cartoon-loop-109009.mp3" type="audio/mpeg">
    </audio>
    <!-- 獲勝音效 -->
    <audio ref="winSound" preload="auto">
      <source src="@/assets/HTwbActAssets/gameSounds/success-fanfare-trumpets-6185.mp3" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
// 導入頭像圖片
import pandaAvatar from '@/assets/Openclipart/animals_panda.png'
import catAvatar from '@/assets/Openclipart/animals_cat1.png'
import bearAvatar from '@/assets/Openclipart/animals_bear.png'
import foxAvatar from '@/assets/Openclipart/animals_fox.png'
import rabbitAvatar from '@/assets/Openclipart/animals_rabbit.png'
import monkeyAvatar from '@/assets/Openclipart/animals_monkey.png'
import lionAvatar from '@/assets/Openclipart/animals_lion.png'
import tigerAvatar from '@/assets/Openclipart/animals_tiger.png'
import elephantAvatar from '@/assets/Openclipart/animals_elephant.png'
import penguinAvatar from '@/assets/Openclipart/animals_penguin.png'
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'HTPickGamePlay',
  components: {
    SvgIcon
  },
  data() {
    return {
      // 通信橋接器
      messageBridge: null,
      
      // 轉盤相關變數
      spinning: false,
      wheelCanvas: null,
      wheelCtx: null,
      wheelRadius: 0,
      wheelCenterX: 0,
      wheelCenterY: 0,
      selectedSegment: null,
      rotationAngle: 0,
      spinningSpeed: 0,
      currentCandidates: [],
      candidatesTimer: null,
      allCandidatesCache: [],
      textOpacity: 1.0, // 文字透明度
      textFading: false, // 文字是否正在淡入淡出
      isResetMode: false, // 是否處於重置模式
      
      // 全局資料
      pickupData: {
        pickupType: "Client",
        memberList: []
      },
      // 全局變數存儲當前獲勝者
      currentWinner: null,
      audioInitialized: false
    }
  },
  mounted() {
    // 初始化通信橋接器
    this.initMessageBridge();
    
    // 監聽來自外部的訊息
    this.setupMessageListener();
    
    // 發送初始化訊息
    this.sendInitMessage();
   
  },

  beforeUnmount() {
    // 清理所有定時器和資源
    this.stopCandidatesRotation();
    
    // 停止轉盤旋轉動畫
    this.spinning = false;
    
    // 清理 Canvas 相關資源
    if (this.wheelCanvas) {
      this.wheelCtx = null;
    }
  },
  methods: {
    // 初始化通信橋接器
    initMessageBridge() {
      // 通信工具類
      const MessageBridge = {
        // 環境類型
        ENV: {
          WEBVIEW: 'webview',
          WEB: 'web'
        },
        // 當前環境
        currentEnv: 'webview',
        // 初始化
        init() {
          this.currentEnv = window?.chrome?.webview ? this.ENV.WEBVIEW : this.ENV.WEB;
          return this;
        },
        // 發送消息
        postMessage(data, origin = '*') {
          if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.postMessage(data);
          } else {
            window.postMessage(data, origin);
          }
        },
        // 添加消息監聽器
        addEventListener(callback) {
          if (this.currentEnv === this.ENV.WEBVIEW) {
            window?.chrome?.webview.addEventListener('message', event => {
              callback(event);
            });
          } else {
            window.addEventListener('message', event => {
              callback(event);
            });
          }
        }
      };
      
      // 初始化消息橋接器
      this.messageBridge = MessageBridge.init();
    },

    // 設置訊息監聽器
    setupMessageListener() {
      // 使用通信橋接器監聽來自外部的 Init.PickGame 訊息
      this.messageBridge.addEventListener((event) => {
        const msg = event.data;
        console.log('收到訊息:', msg);
        if (msg.action === 'Init.PickGame') {
          this.handleInitMessage(msg);
          // 將設定存入 sessionStorage
          sessionStorage.setItem('PickGameConfig', JSON.stringify(msg.data));
        }
      });
    },

    // 發送初始化訊息
    sendInitMessage() {
      this.messageBridge.postMessage({
        action: 'Init.PickGame',
        data: {
          pickupType: "Client",
          // isSmartPickup: false,
          memberList: [
            { seatID: 1, memberName: "Apple", pickedTimes: 11, avatar: "" },
            { seatID: 2, memberName: "Banana", pickedTimes: 1, avatar: "" },
            { seatID: 3, memberName: "Orange", pickedTimes: 11, avatar: "" },
            { seatID: 4, memberName: "Grape", pickedTimes: 0, avatar: "" },
            { seatID: 5, memberName: "Mango", pickedTimes: 10, avatar: "" },
            { seatID: 6, memberName: "Peach", pickedTimes: 5, avatar: "" },
            { seatID: 7, memberName: "Cherry", pickedTimes: 7, avatar: "" },
            { seatID: 8, memberName: "Lemon", pickedTimes: 12, avatar: "" },
            { seatID: 9, memberName: "Berry", pickedTimes: 15, avatar: "" },
            { seatID: 10, memberName: "Melon", pickedTimes: 1, avatar: "" }
          ],
          // groupList: [
          //   { groupID: "1", groupName: "Group_1", pickedTimes: 5, memberList: [1, 2, 3] },
          //   { groupID: "2", groupName: "Group_2", pickedTimes: 7, memberList: [4, 5] },
          //   { groupID: "3", groupName: "Group_3", pickedTimes: 0, memberList: [6, 7] },
          //   { groupID: "4", groupName: "Group_4", pickedTimes: 4, memberList: [8, 9, 10] }
          // ]
        }
      });
    },

    // 處理初始化訊息
    handleInitMessage(message) {
      console.log('收到初始化訊息:', message);
      
      // 隨機頭像陣列
      const avatars = [pandaAvatar, catAvatar, bearAvatar, foxAvatar, rabbitAvatar, 
                      monkeyAvatar, lionAvatar, tigerAvatar, elephantAvatar, penguinAvatar];
      
      // 為沒有頭像的成員隨機分配頭像
      if (message.data.memberList) {
        message.data.memberList = message.data.memberList.map(member => ({
          ...member,
          avatar: member.avatar || avatars[Math.floor(Math.random() * avatars.length)]
        }));
      }
      
      // 豐富成員資料，加入群組資訊
      if (message.data.memberList) {
        message.data.memberList = this.enrichMembersWithGroup(message.data);
      }
      
      this.pickupData = message.data;
      
      // 初始化遊戲
      this.initPickGame();
    },

    // 初始化 Pick 遊戲
    initPickGame() {
      // 初始化轉盤畫布
      this.initWheel();
      
      // 獲取候選人並緩存
      this.allCandidatesCache = this.getPickCandidates();
      this.currentCandidates = this.randomCandidates(this.allCandidatesCache);
      
      // console.log('候選人:', this.allCandidatesCache);
      // console.log('當前候選人:', this.currentCandidates);
      
      // 繪製轉盤
      this.drawWheel();
      
      // 開始定時切換候選人
      this.startCandidatesRotation();
    },


    enrichMembersWithGroup(data) {
      const memberList = data.memberList;
      const groupList = data.groupList || [];

      // 建立 seatID 到 group 的對應表
      const seatToGroupMap = {};
      groupList.forEach(group => {
        group.memberList.forEach(seatID => {
          seatToGroupMap[seatID] = {
            groupID: group.groupID,
            groupName: group.groupName
          };
        });
      });

      // 將 group 資訊合併進每位 member 中
      const enrichedMemberList = memberList.map(member => {
        const groupInfo = seatToGroupMap[member.seatID] || {
          groupID: "",
          groupName: ""
        };
        return Object.assign({}, member, groupInfo);
      });

      return enrichedMemberList;
    },

    // 初始化轉盤
    initWheel() {
      this.wheelCanvas = document.getElementById('wheel');
      this.wheelCtx = this.wheelCanvas.getContext('2d');
      this.wheelRadius = this.wheelCanvas.width / 2 - 10; // 比原本少 20px，產生 padding 效果
      this.wheelCenterX = this.wheelCanvas.width / 2;
      this.wheelCenterY = this.wheelCanvas.height / 2;
    },

    // 隨機選擇10個候選人
    randomCandidates(allCandidates) {
      let candidates;
      let tempCandidates = [...allCandidates]; // 創建一個副本以避免修改原始數據

      if (tempCandidates.length > 10) {
        candidates = [];
        for (let i = 0; i < 10; i++) {
          if (tempCandidates.length === 0) break;
          const randomIndex = Math.floor(Math.random() * tempCandidates.length);
          candidates.push(tempCandidates.splice(randomIndex, 1)[0]);
        }
      } else {
        candidates = [];
        while (tempCandidates.length > 0) {
          const randomIndex = Math.floor(Math.random() * tempCandidates.length);
          candidates.push(tempCandidates.splice(randomIndex, 1)[0]);
        }
      }
      return candidates;
    },

    // 開始定時切換候選人
    startCandidatesRotation() {
      if (this.candidatesTimer) {
        clearInterval(this.candidatesTimer);
      }

      // 立即更新一次
      this.currentCandidates = this.randomCandidates(this.allCandidatesCache);
      this.drawWheel();

      // 設置定時器，每2秒更新一次
      this.candidatesTimer = setInterval(() => {
        if (!this.spinning) { // 只在非旋轉狀態更新
          // 開始文字淡出
          this.startTextFade(() => {
            // 更新候選人
            this.currentCandidates = this.randomCandidates(this.allCandidatesCache);
            // 重繪轉盤
            this.drawWheel();
          });
        }
      }, 2000);
    },

    // 停止定時切換
    stopCandidatesRotation() {
      if (this.candidatesTimer) {
        clearInterval(this.candidatesTimer);
        this.candidatesTimer = null;
      }
    },

    // 開始文字淡入淡出
    startTextFade(callback) {
      if (this.textFading) return;
      this.textFading = true;

      // 文字淡出
      let fadeOutInterval = setInterval(() => {
        this.textOpacity -= 0.1;
        if (this.textOpacity <= 0) {
          clearInterval(fadeOutInterval);
          this.textOpacity = 0;

          // 執行回調（更新候選人）
          if (callback) callback();

          // 文字淡入
          let fadeInInterval = setInterval(() => {
            this.textOpacity += 0.1;
            if (this.textOpacity >= 1) {
              clearInterval(fadeInInterval);
              this.textOpacity = 1.0;
              this.textFading = false;
            }
            this.drawWheel();
          }, 30);
        }
        this.drawWheel();
      }, 30);
    },

    // 繪製轉盤
    drawWheel() {
      // 確保 canvas 已初始化
      if (!this.wheelCtx || !this.wheelCanvas) {
        console.warn('Canvas 尚未初始化，跳過繪製');
        return;
      }
      
      // 清空畫布
      this.wheelCtx.clearRect(0, 0, this.wheelCanvas.width, this.wheelCanvas.height);

      // 使用當前的候選人集合
      const candidates = this.currentCandidates;

      if (candidates.length === 0) {
        // 如果沒有候選項，繪製空轉盤
        this.wheelCtx.beginPath();
        this.wheelCtx.arc(this.wheelCenterX, this.wheelCenterY, this.wheelRadius, 0, 2 * Math.PI);
        this.wheelCtx.fillStyle = '#f0f0f0';
        this.wheelCtx.fill();
        this.wheelCtx.stroke();

        // 顯示無候選項文字
        this.wheelCtx.fillStyle = '#333';
        this.wheelCtx.font = '16px Arial';
        this.wheelCtx.textAlign = 'center';
        this.wheelCtx.fillText('無候選項', this.wheelCenterX, this.wheelCenterY);
        return;
      }

      // 計算每個扇形的角度
      const segmentAngle = (2 * Math.PI) / candidates.length;

      // 繪製每個扇形
      candidates.forEach((candidate, index) => {
        const startAngle = index * segmentAngle + this.rotationAngle;
        const endAngle = (index + 1) * segmentAngle + this.rotationAngle;

        this.wheelCtx.beginPath();
        this.wheelCtx.moveTo(this.wheelCenterX, this.wheelCenterY);
        this.wheelCtx.arc(this.wheelCenterX, this.wheelCenterY, this.wheelRadius, startAngle, endAngle);
        this.wheelCtx.closePath();

        // 使用 HSL 彩色填色，色相隨 index 改變
        const hue = (index * 360) / candidates.length;
        this.wheelCtx.fillStyle = `hsl(${hue}, 70%, 45%)`;
        this.wheelCtx.fill();

        // 繪製文字
        this.wheelCtx.save();
        this.wheelCtx.translate(this.wheelCenterX, this.wheelCenterY);
        this.wheelCtx.rotate(startAngle + segmentAngle / 2);
        this.wheelCtx.textAlign = 'right';
        this.wheelCtx.fillStyle = `rgba(255, 255, 255, ${this.textOpacity})`; // 使用透明度

        // 添加文字大小的過渡效果
        const scaleFactor = 1 + (Math.sin(this.rotationAngle + (index * segmentAngle + segmentAngle / 2)) * 0.1);
        this.wheelCtx.font = `${26 * scaleFactor}px Arial`;

        // 根據名稱長度調整位置
        const textRadius = this.wheelRadius * 0.75;
        let label = this.pickupData.pickupType === 'Client' ? candidate.memberName : candidate.groupName;
        if (label && label.length > 10) {
          label = label.slice(0, 10) + '...';
        }
        this.wheelCtx.fillText(label, textRadius, 5);
        this.wheelCtx.restore();
      });

      // 繪製指針
      this.wheelCtx.save();
      this.wheelCtx.beginPath();
      this.wheelCtx.moveTo(this.wheelCenterX + this.wheelRadius - 65, this.wheelCenterY);
      this.wheelCtx.lineTo(this.wheelCenterX + this.wheelRadius + 25, this.wheelCenterY + 15);
      this.wheelCtx.lineTo(this.wheelCenterX + this.wheelRadius + 25, this.wheelCenterY - 15);
      this.wheelCtx.closePath();
      this.wheelCtx.fillStyle = '#e74c3c';
      this.wheelCtx.fill();
      this.wheelCtx.restore();
    },

    // 轉動轉盤動畫
    spinWheel() {
      // 發送遊戲開始協議給 WebView
      this.messageBridge.postMessage({
        action: "Game.Start",
        type: "pick"
      });

      // 隱藏開始按鈕
      const pickButton = document.getElementById('pick-button');
      pickButton.style.opacity = 0;


      if (this.spinning) return;

      this.spinning = true;
      this.spinningSpeed = 0.2 + Math.random() * 0.2; // 隨機速度
      const spinTime = 3000 + Math.random() * 2000; // 隨機旋轉時間
      const slowdownRate = this.spinningSpeed / spinTime;

      // 播放轉盤音效
      const wheelSound = this.$refs.wheelSound;
      wheelSound.currentTime = 0; // 重置音效時間
      wheelSound.volume = 1.0; // 設定音量為100%
      
      // 延遲播放避免與初始化衝突
      setTimeout(() => {
        wheelSound.play().catch(error => {
          console.log('播放音效失敗:', error);
        });
        
        // 設定11秒後自動停止音效
        setTimeout(() => {
          if (!wheelSound.paused) {
            wheelSound.pause();
            wheelSound.currentTime = 0;
          }
        }, 11000);
      }, 100);

      // 等待轉盤停止旋轉後顯示結果
      setTimeout(() => {
        pickButton.style.opacity = 1;
      }, spinTime);

      // 清空結果顯示
      document.getElementById('wheel-result').textContent = '';

      // 開始旋轉動畫
      let startTime = null;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsedTime = timestamp - startTime;

        // 計算當前速度（逐漸減慢）
        const currentSpeed = Math.max(0, this.spinningSpeed - (elapsedTime * slowdownRate));

        // 更新角度
        this.rotationAngle += currentSpeed;

        // 繪製轉盤
        this.drawWheel();

        if (elapsedTime < spinTime) {
          requestAnimationFrame(animate);
        } else {
          // 動畫結束，選擇結果
          this.spinning = false;
          this.selectWinner();
        }
      };

      requestAnimationFrame(animate);
    },

    // 選擇獲勝者
    selectWinner() {
      // 停止候選人切換
      this.stopCandidatesRotation();

      // 停止轉盤音效
      const wheelSound = this.$refs.wheelSound;
      if (!wheelSound.paused) {
        wheelSound.pause();
        wheelSound.currentTime = 0;
      }
      
      // 播放獲勝音效
      const winSound = this.$refs.winSound;
      winSound.currentTime = 0;
      winSound.play().catch(error => {
        console.log('播放獲勝音效失敗:', error);
      });

      // 延遲1秒後重置轉盤，準備下一輪選擇
      setTimeout(() => {
        this.rotationAngle = 0;
        // 重新開始候選人切換
        this.startCandidatesRotation();
        // 確保按鈕處於播放模式
        this.updateButtonMode(false);
      }, 2000);

      // 計算指針指向的扇形
      const segmentAngle = (2 * Math.PI) / this.currentCandidates.length;
      const normalizedAngle = (this.rotationAngle % (2 * Math.PI)) + (2 * Math.PI);
      const winnerIndex = Math.floor(this.currentCandidates.length - (normalizedAngle / segmentAngle) % this.currentCandidates.length);
      const winner = this.currentCandidates[winnerIndex % this.currentCandidates.length];
      
      // 保存當前獲勝者到全局變數
      this.currentWinner = winner;

      // 獲取結果元素
      const resultElement = document.getElementById('wheel-result');

      // 清空之前的內容
      resultElement.innerHTML = '';
      resultElement.className = 'hidden';

      // 加入頭像
      const avatarElement = document.createElement('div');
      avatarElement.className = 'avatar';
      if (winner.avatar) {
        // console.log('設定頭像:', winner.avatar); // 調試用
        avatarElement.style.backgroundImage = `url(${winner.avatar})`;
        avatarElement.style.backgroundSize = 'cover';
        avatarElement.style.backgroundPosition = 'center';
        avatarElement.style.backgroundRepeat = 'no-repeat';
      } else {
        const char = winner.memberName ? winner.memberName[0] : '';
        const color = this.getRandomColor();
        avatarElement.style.backgroundColor = color;
        avatarElement.innerHTML = `<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;border-radius:50%;color:#fff;font-size:40px;position:absolute;top:-20px">${char}</div>`;
      }
      resultElement.appendChild(avatarElement);

      // 加入座位ID
      const seatIdElement = document.createElement('div');
      seatIdElement.className = 'seat-id';
      seatIdElement.textContent = this.pickupData.pickupType === 'Client' ? winner.seatID : winner.groupID || '';
      resultElement.appendChild(seatIdElement);

      // 獲取結果文字
      const resultTextElement = document.createElement('div');
      resultTextElement.className = 'result-info';
      const resultTextTemplate = document.createElement('template');
      resultTextTemplate.innerHTML = `
        <div class="result-group">${winner.groupName || ''}</div>
        <div class="result-name">${winner.memberName || ''}</div>
      `;
      resultTextElement.appendChild(resultTextTemplate.content.cloneNode(true));
      resultElement.appendChild(resultTextElement);

      // 顯示結果
      resultElement.className = 'show-winner';


      // 高亮顯示獲勝扇形
      this.wheelCtx.beginPath();
      const startAngle = winnerIndex * segmentAngle + this.rotationAngle;
      const endAngle = (winnerIndex + 1) * segmentAngle + this.rotationAngle;
      this.wheelCtx.moveTo(this.wheelCenterX, this.wheelCenterY);
      this.wheelCtx.arc(this.wheelCenterX, this.wheelCenterY, this.wheelRadius, startAngle, endAngle);
      this.wheelCtx.closePath();
      this.wheelCtx.fillStyle = 'rgba(255, 215, 0, 0.5)';
      this.wheelCtx.fill();
      this.wheelCtx.lineWidth = 3;
      this.wheelCtx.strokeStyle = '#ffd700';
      this.wheelCtx.stroke();
      this.wheelCtx.lineWidth = 1;
      this.wheelCtx.strokeStyle = '#000';
      this.wheelCtx.beginPath();
      this.wheelCtx.moveTo(this.wheelCenterX + this.wheelRadius - 65, this.wheelCenterY);
      this.wheelCtx.lineTo(this.wheelCenterX + this.wheelRadius + 25, this.wheelCenterY + 15);
      this.wheelCtx.lineTo(this.wheelCenterX + this.wheelRadius + 25, this.wheelCenterY - 15);
      this.wheelCtx.closePath();
      this.wheelCtx.fillStyle = '#e74c3c';
      this.wheelCtx.fill();
      this.wheelCtx.restore();

      // 發送挑選結果
      this.messageBridge.postMessage({
        action: 'Pickup.Result',
        pickupType: this.pickupData.pickupType,
        pickedList: this.pickupData.pickupType === 'Client' ? [winner.seatID] : [winner.groupID]
      });
    },

    // 挑人主程式
    handlePickButtonClick() {
      // 首次點擊時初始化音效
      if (!this.audioInitialized) {
        this.initializeAudio();
        this.audioInitialized = true;
      }
      
      // 停止候選人切換
      this.stopCandidatesRotation();

      if (this.currentCandidates.length === 0) {
        document.getElementById('wheel-result').textContent = '無候選項';
        return;
      }

      // 開始轉動轉盤
      this.spinWheel();
    },
    
    initializeAudio() {
      // 初始化所有音效
      const audioElements = [this.$refs.wheelSound, this.$refs.winSound];
      
      audioElements.forEach((audio, index) => {
        if (audio) {
          // 延遲初始化避免衝突
          setTimeout(() => {
            audio.muted = true;
            audio.play().then(() => {
              audio.muted = false;
              audio.pause();
              audio.currentTime = 0;
            }).catch(e => console.log('音效初始化失敗:', e));
          }, index * 50); // 每個音效間隔50ms初始化
        }
      });
    },

    /**
     * 按協議先整理要挑選之人
     */
    getPickCandidates() {
      const pickupType = this.pickupData.pickupType||"Client";
      let candidates = [];

      console.log(this.pickupData, 'pickupData');

      switch (pickupType) {
        case 'Client':
          // 個人挑選
          if (this.pickupData.memberList && this.pickupData.memberList.length > 0) {
            if (this.pickupData.isSmartPickup) {
              // 依據智能挑選規則過濾成員
              candidates = this.pickupData.memberList
                .filter(member => {
                  // 如果options中包含成員的seatID，則納入候選
                  return this.pickupData.options.includes(member.seatID.toString());
                })
                .map(member => member);
            } else {
              candidates = this.pickupData.memberList.map(member => member);
            }
          }
          break;

        case 'Group':
          // 組別挑選
          if (this.pickupData.groupList && this.pickupData.groupList.length > 0) {
            if (this.pickupData.isSmartPickup) {
              // 依據智能挑選規則過濾成員
              candidates = this.pickupData.groupList
                .filter(group => {
                  // 如果options中包含成員的seatID，則納入候選
                  return this.pickupData.options.includes(group.groupID);
                })
                .map(group => {
                  return group;
                });
            } else {
              candidates = this.pickupData.groupList.map(group => group);
            }
          }
          break;

        case 'General':
          // 一般挑選
          if (this.pickupData.options && this.pickupData.options.length > 0) {
            candidates = this.pickupData.options.map(option => ({
              name: option
            }));
          }
          break;
      }
      return candidates;
    },

    // 生成隨機顏色
    getRandomColor() {
      const colors = [
        '#1abc9c', '#2ecc71', '#3498db', '#9b59b6', '#34495e',
        '#16a085', '#27ae60', '#2980b9', '#8e44ad', '#2c3e50',
        '#f1c40f', '#e67e22', '#e74c3c', '#ecf0f1', '#95a5a6',
        '#f39c12', '#d35400', '#c0392b', '#bdc3c7', '#7f8c8d'
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },

    //更新按鈕模式
    updateButtonMode(reset) {
      const pickButton = document.getElementById('pick-button');
      this.isResetMode = reset;

      // 播放模式 - 顯示播放圖標
      pickButton.style.transition = 'all 2s';
      pickButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"
          fill="currentColor">
          <path d="M8 5v14l11-7z" />
        </svg>
      `;
      pickButton.style.transition = '';
    },




    // 前往設定頁面
    goToSettings() {
      // 停止所有計時器和動畫
      this.stopCandidatesRotation();
      
      // 強制停止轉盤旋轉動畫
      this.spinning = false;
      
      // 停止文字淡入淡出效果
      this.textFading = false;
      
      // 停止所有音效
      const audioElements = [this.$refs.wheelSound, this.$refs.winSound];
      audioElements.forEach(audio => {
        if (audio && !audio.paused) {
          audio.pause();
          audio.currentTime = 0;
        }
      });
      
      // 重置遊戲狀態
      this.selectedSegment = null;
      this.rotationAngle = 0;
      this.spinningSpeed = 0;
      this.currentWinner = null;
      this.textOpacity = 1.0;
      
      // 清空候選人資料
      this.currentCandidates = [];
      this.allCandidatesCache = [];
      
      // 隱藏結果顯示
      const wheelResult = document.getElementById('wheel-result');
      if (wheelResult) {
        wheelResult.className = 'hidden';
        wheelResult.innerHTML = '';
      }
      
      
      // 重置播放按鈕
      const pickButton = document.getElementById('pick-button');
      if (pickButton) {
        pickButton.style.opacity = 1;
      }
      
      // 清空 canvas
      if (this.wheelCtx && this.wheelCanvas) {
        this.wheelCtx.clearRect(0, 0, this.wheelCanvas.width, this.wheelCanvas.height);
      }
      
      // 路由到設定頁面
      this.$router.push('/ht-pickgame-setting');
    },

  }
}
</script>

<style lang="less">
/* 隨機挑選系統樣式表 - 極簡版 */
.pikaplay-container {
/* 基本樣式設定 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
  width: 100%;
  margin: 0 auto;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  font-family: 'Microsoft JhengHei', 'PingFang TC', sans-serif;
  background: linear-gradient(to bottom, #2c5364 0%, #203a43 30%, #0f2027 100%);
  line-height: 1.6;
  color: #333;
  min-height: 100vh;

  /* 結果卡片樣式 */
  .result-card {
    width: 100%;
    height: calc(100vh - 10px);
    min-width: 1000px;
    padding: 30px;
  }

  .result-flex-wrap {
    flex: 2;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 轉盤容器樣式 */
  .wheel-container {
    position: relative;
    width: 600px;
    height: 600px;
    margin: 0 auto;
    left: 120px;

    /* 轉盤結果樣式 */
    #wheel-result {
      position: absolute;
      left: -230px;
      top: 170px;
      width: 240px;
      height: 240px;
      margin-right: 40px;
      background-color: transparent;

      &.hidden {
        opacity: 0;
        display: none;
      }

      &.show-winner {
        display: block;
        opacity: 1;
      }

      .seat-id {
        position: absolute;
        top: 20px;
        left: 0px;
        background: #6200ea;
        color: white;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size:14px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        border: 2px solid white;
        z-index: 10;
      }

      .result-info {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 8px 0;
        text-align: center;
        z-index: 2;

        .result-group {
          font-size: 24px;
          color: red;
          display: inline-block;
          padding: 2px 8px;
          border-radius: 12px;
          background-color: rgba(255, 255, 255, 0.7);
          font-weight: bold;
          margin-bottom: 2px;
        }

        .result-name {
          font-size: 40px;
          font-weight: bold;
          color: blue;
          text-shadow: 0 0 5px rgb(255, 221, 0),
                       0 0 10px rgb(255, 234, 0),
                       0 0 15px rgba(255, 183, 0, 0.2);
        }
      }
    }

    /* 按鈕樣式 */
    #pick-button {
      background-color: #d1e8ff;
      color: rgb(0, 0, 0);
      font-size: 1.2rem;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      transition: all 0.3s;
      
      /* 定位在轉盤中心 */
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #b8dbff;
      }

      svg {
        fill: black;
        width: 70px;
        height: 70px;
      }
    }



    
    /* 設定按鈕樣式 */
    .setting-button {
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #d1e8ff;
      border: 1px solid transparent;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;

      &:hover {
        background-color: #b8dbff;
      }

      .setting-icon {
        width: 40px;
        height: 40px;
        
        svg {
          width: 100%;
          height: 100%;
          * {
            fill: black !important;
          }
        
        }
      }
    }
  }

  .card-flex-wrap {
    flex: 4;
  }
  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
}

</style>